import React from 'react';
import { HeaderContainer, Logo } from './styles';
import LOGO from 'assests/images/logo.png';
import BACKDROP from 'assests/images/bgLastShadow.webp';
import { useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
    const navigate = useNavigate();

    return (
        <HeaderContainer>
            <Logo onClick={()=>navigate('/')}><img src={LOGO} alt="logo" /></Logo>
            <button
                className="cta-button __contact"
                onClick={() => {
                    navigate('/contact');
                }}
            >
                Contact Us
            </button>
            <img src={BACKDROP} className='backdrop' alt="" />
        </HeaderContainer>
    );
};

export default Header;